import { render, staticRenderFns } from "./CandidateInterviewProcessing.vue?vue&type=template&id=2a6a01e0&scoped=true&"
import script from "./CandidateInterviewProcessing.vue?vue&type=script&lang=js&"
export * from "./CandidateInterviewProcessing.vue?vue&type=script&lang=js&"
import style0 from "./CandidateInterviewProcessing.vue?vue&type=style&index=0&id=2a6a01e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6a01e0",
  null
  
)

/* custom blocks */
import block0 from "./CandidateInterviewProcessing.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./CandidateInterviewProcessing.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
